import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { apiService } from '../services/apiService';
import { useAuth } from '../contexts/AuthContext';

// Fires a page-view beacon on every SPA route change (pathname only — query/hash changes are ignored).
// Only AUTHENTICATED users are tracked: the beacon hits an auth-guarded endpoint, so firing it on the
// unauthenticated /login page would 401 and trip the global auth interceptor into a redirect loop.
// The server persists it only when PAGE_VIEW_TRACKING=on; the call is fire-and-forget and swallows
// errors, so tracking never affects navigation. Mount once inside the Router (e.g. the app root).
export default function usePageViewTracker() {
  const location = useLocation();
  const { user } = useAuth();
  const prev = useRef(null);
  useEffect(() => {
    if (!user) { prev.current = null; return; } // not logged in → don't beacon; reset on logout
    const route = location.pathname;
    if (prev.current === route) return;
    apiService.recordPageView({ route, from: prev.current });
    prev.current = route;
  }, [location.pathname, user]);
}
